/**
 * Calculates the discount factor
 * @param {object} data
 * @param {number} data.annualInterestRate Annual interest rate in percent
 * @param {number} data.loanTermMonths Loan term in months
 * @returns {number}
 */
export function getDiscountFactor(_ref) {
  var annualInterestRate = _ref.annualInterestRate,
      loanTermMonths = _ref.loanTermMonths;
  var monthlyInterestRate = annualInterestRate / 12;
  return (1 - Math.pow(1 + monthlyInterestRate, -loanTermMonths)) / monthlyInterestRate;
}
/**
 * Amortizes a loan (solves for monthly payment)
 * @param {object} data
 * @param {number} data.annualInterestRate Annual interest rate in percent
 * @param {number} data.loanAmount The loan amount
 * @param {number} data.loanTermMonths Loan term in months
 * @returns {number}
 */

export var amortize = function amortize(_ref2) {
  var annualInterestRate = _ref2.annualInterestRate,
      loanAmount = _ref2.loanAmount,
      loanTermMonths = _ref2.loanTermMonths;
  return loanAmount / getDiscountFactor({
    annualInterestRate: annualInterestRate,
    loanTermMonths: loanTermMonths
  });
};